import svg_raw_light from './phi-logo.svg';
import svg_raw_dark from './phi-logo-dark.svg';
import { h } from 'vue';

export const PhiLogo = (light: boolean, size = '2rem') => h('img', {
    src: light ? svg_raw_light : svg_raw_dark,
    style: {
        width: size,
        height: size,
    },
});
